<nav aria-label="breadcrumb">
    <ol class="breadcrumb">
        <li class="breadcrumb-item">
            <a routerLink="/dashboard" style="color: #003E53;">Dashboard</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
            Customers
        </li>
    </ol>
</nav>


<div class="row">
    <div class="col-xl-12">
        <app-card cardTitle="Basic Table" [options]="false" blockClass="table-border-style">
            <div class="row gx-3 gy-2 align-items-center">
                <!-- Title -->
                <div class="col-md-6 col-12">
                    <h5 class="mb-0 text-dark fw-bold">
                        Customers
                    </h5>
                </div>

                <!-- Generate + Filter Section -->
                <div
                    class="col-md-6 col-12 d-flex justify-content-md-end justify-content-start align-items-center gap-2 flex-wrap">
                    <mat-form-field class="" (click)="picker.open()">
                        <mat-label>Filter by Registration Date</mat-label>
                        <mat-date-range-input [rangePicker]="picker">
                            <input matStartDate placeholder="Start Date" [(ngModel)]="filter.startdate" readonly />
                            <input matEndDate placeholder="End Date" [(ngModel)]="filter.enddate"
                                (dateChange)="getAllCustomers(null)" readonly />
                        </mat-date-range-input>
                        <div matSuffix class="d-flex align-items-center gap-1">
                            @if (filter.startdate || filter.enddate) {
                            <mat-icon (click)="clearDateRange()" class="clear-icon"
                                style="cursor: pointer;">close</mat-icon>
                            }
                            @else {

                            <mat-datepicker-toggle [for]="picker"></mat-datepicker-toggle>
                            }
                        </div>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                    </mat-form-field>
                </div>
            </div>
            <hr class="m-0 p-0">
            <hr class="m-0 p-0">

            <div class="row ">
                @if(!isCompanyLoggedIn){
                <div class="col-lg-3 mt-1">
                    <ng-select [items]="customersSelection" bindLabel="label" bindValue="value"
                        placeholder="Filter by Customer Source" name="customerSelection"
                        [(ngModel)]="filter.customerSelection" (change)="getAllCustomers(null)">
                        >
                    </ng-select>
                </div>
                }

                <div class="col-lg-3">
                    <mat-form-field mappearance="outline" class="dense w-100">
                        <mat-label>Search By Name or Email</mat-label>
                        <input matInput [(ngModel)]="filter.name" name="name" (input)="onNameInputChange($event)">
                    </mat-form-field>
                </div>

                <div class="col-lg-3">
                    <mat-form-field mappearance="outline" class="dense w-100">
                        <mat-label>Search By City/State</mat-label>
                        <input matInput [(ngModel)]="filter.cityState" name="cityState"
                            (input)="onCityStateChange($event)">
                    </mat-form-field>
                </div>

                @if(!isCompanyLoggedIn && filter.customerSelection== 1 ){
                <div class="col-lg-3 ">
                    <ng-select [items]="allCompanies" bindLabel="name" bindValue="_id" placeholder="Select Company"
                        [(ngModel)]="filter.companyId" name="companyId" (change)="companyFilter($event)"
                        [appendTo]="'body'" dropdownPosition="bottom">
                    </ng-select>
                </div>
                }

            </div>

            <div class="table-responsive">
                <div class="mat-elevation-z8">
                    <table mat-table [dataSource]="dataSource" class="compact-table table-bordered table-hover">
                        <!-- Position Column -->
                        <ng-container matColumnDef="position">
                            <th mat-header-cell *matHeaderCellDef>Sr. No</th>
                            <td mat-cell *matCellDef="let row; let index = index">
                                {{ index + 1 + (paginator.pageIndex * paginator.pageSize) }}
                            </td>
                        </ng-container>

                        <!-- Name Column -->
                        <!-- Name Column -->
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef> Name </th>
                            <td mat-cell *matCellDef="let element">
                                @if (element.name) {
                                {{ element.name }}
                                } @else {
                                <span class="text-muted">-</span>
                                }
                            </td>
                        </ng-container>

                        <!-- Email -->
                        <ng-container matColumnDef="email">
                            <th mat-header-cell *matHeaderCellDef> Email </th>
                            <td mat-cell *matCellDef="let element">
                                @if (element?.email) {
                                {{ element.email }}
                                } @else {
                                <span class="text-muted">-</span>
                                }
                            </td>
                        </ng-container>

                        <!-- Phone -->
                        <ng-container matColumnDef="phone">
                            <th mat-header-cell *matHeaderCellDef> Phone </th>
                            <td mat-cell *matCellDef="let element">
                                @if (element?.phone) {
                                {{ element.phone }}
                                } @else {
                                <span class="text-muted">-</span>
                                }
                            </td>
                        </ng-container>

                        <!-- Gender -->
                        <ng-container matColumnDef="gender">
                            <th mat-header-cell *matHeaderCellDef> Gender </th>
                            <td mat-cell *matCellDef="let element">
                                @if (element?.gender == 1) {
                                Male
                                } @else if (element?.gender == 2) {
                                Female
                                } @else if (element?.gender == 3) {
                                Other
                                } @else {
                                <span class="text-muted">-</span>
                                }
                            </td>
                        </ng-container>

                        <!-- DOB/Age -->
                        <ng-container matColumnDef="dob">
                            <th mat-header-cell *matHeaderCellDef> Age </th>
                            <td mat-cell *matCellDef="let element">
                                @if (element?.dob) {
                                {{ calculateAge(element.dob) }}
                                } @else {
                                <span class="text-muted">-</span>
                                }
                            </td>
                        </ng-container>

                        <!-- State -->
                        <ng-container matColumnDef="state">
                            <th mat-header-cell *matHeaderCellDef> State </th>
                            <td mat-cell *matCellDef="let element">
                                @if (element?.state) {
                                {{ element.state }}
                                } @else {
                                <span class="text-muted">-</span>
                                }
                            </td>
                        </ng-container>

                        <!-- City -->
                        <ng-container matColumnDef="city">
                            <th mat-header-cell *matHeaderCellDef> City </th>
                            <td mat-cell *matCellDef="let element">
                                @if (element?.city) {
                                {{ element.city }}
                                } @else {
                                <span class="text-muted">-</span>
                                }
                            </td>
                        </ng-container>

                        <!-- Address -->
                        <ng-container matColumnDef="address">
                            <th mat-header-cell *matHeaderCellDef> Address </th>
                            <td mat-cell *matCellDef="let element">
                                <div [title]="getFullAddress(element)">
                                    {{ getPartialAddress(element) }}
                                </div>
                            </td>
                        </ng-container>

                        
                        <ng-container matColumnDef="sampleCount">
                            <th mat-header-cell *matHeaderCellDef> Total Samples </th>
                            <td mat-cell *matCellDef="let element">
                                @if(element.sampleCount){
                                {{element.sampleCount}}
                                }
                                @else {
                                -
                                }
                            </td>
                        </ng-container>


                        <!-- Symbol Column -->
                        <ng-container matColumnDef="createdAt">
                            <th mat-header-cell *matHeaderCellDef class="text-nowrap"> Registered At </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.createdAt | date:'dd/MM/yyyy' }}<br>
                                <small>{{ element.createdAt | date:'hh:mm a' }}</small>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="samples">
                            <th mat-header-cell *matHeaderCellDef class="text-nowrap"> Samples </th>
                            <td mat-cell *matCellDef="let element">
                                <button mat-icon-button class="btn btn-sm "
                                    [routerLink]="['/sample/issuedToDistributors',element._id,3]">
                                    <mat-icon class="c_btn">visibility</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="t_head"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell text-center" [attr.colspan]="displayedColumns.length">
                                No data available
                            </td>
                        </tr>
                    </table>
                </div>
            </div>

            <mat-paginator #paginator [length]="total" [pageSize]="10" [pageSizeOptions]="[10, 20, 50, 100]"
                (page)="getAllCustomers($event)">
            </mat-paginator>
        </app-card>
    </div>
</div>